import React from 'react';
import styled from 'styled-components';

const NavbarContainer = styled.div`
  height: 10vh;
  background-color: #b8b8b8; /* Fundo claro */
  color: black; /* Texto preto para contraste */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;

  @media (max-width: 768px) {
    height: 7vh;
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
    justify-content: center; /* Centraliza tudo quando a tela for muito pequena */
  }
`;

const LogoImage = styled.img`
  height: 60px;
  display: block; /* Para evitar espaçamentos extras abaixo da imagem */
  margin: 0 auto; /* Centraliza a imagem quando o container for reduzido */

  @media (max-width: 768px) {
    height: 50px;
  }

  @media (max-width: 480px) {
    height: 40px;
  }
`;

const Navbar = () => {
  return (
    <NavbarContainer>
      <LogoImage src="logo.png" alt="Logo" />
    </NavbarContainer>
  );
};

export default Navbar;
